/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IPasteData } from "./CopyPaste.types";
import { isNonEmptyArray } from "@adapptio/lib-shared";
import {
	dataToIDT,
	ISchemaConstMapModelEntry,
	TBlueprintIDTNode,
	TGenericBlueprintSchema,
	TGenericModelNode
} from "@adapptio/lib-blueprint";

function deserializeModelData<Model extends TGenericModelNode>(data: any): TBlueprintIDTNode {
	return dataToIDT(data, "dnd://clipboard", [ "$" ]);
}

function deserializeMapEntryData(mapEntry: ISchemaConstMapModelEntry<TGenericBlueprintSchema>): any {
	return { key: deserializeModelData(mapEntry.key), value: deserializeModelData(mapEntry.value) };
}

export function deserializeCopyPasteData(data: string): IPasteData {
	const obj = JSON.parse(data);
	const result: IPasteData = {};

	if (isNonEmptyArray(obj.components)) {
		result.components = obj.components.map((model) => deserializeModelData(model));
	}

	if (isNonEmptyArray(obj.dataSources)) {
		result.dataSources = obj.dataSources.map((model) => deserializeModelData(model));
	}

	if (isNonEmptyArray(obj.parameters)) {
		result.parameters = obj.parameters.map((mapEntry) => deserializeMapEntryData(mapEntry));
	}

	if (isNonEmptyArray(obj.outlets)) {
		result.outlets = obj.outlets.map((mapEntry) => deserializeMapEntryData(mapEntry));
	}

	if (isNonEmptyArray(obj.viewEventNodes)) {
		result.viewEventNodes = obj.viewEventNodes.map((model) => deserializeModelData(model));
	}

	if (isNonEmptyArray(obj.flowNodes)) {
		result.flowNodes = obj.flowNodes.map((model) => deserializeModelData(model));
	}

	return result;
}
